import React, { useState } from 'react'
import { connect } from 'react-redux'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { focusElemnt, isNull, navigation2 } from '../common/helper'
import { SendBranchInquirySMS, getBranchListForAdminUpdate, updateAlert } from '../../store/common/common_action'
import Modal from '../common/modal'
import LineInput from '../common/lineinput'
import DropDownOA from '../common/dropDownOA'
import { Item } from '../common/snippets'
import { Checkbox, FormControlLabel, Stack } from '@mui/material'
import { updateModal } from '../../store/common/common_action'
import Multilineinput from '../common/multilineinput'
import { useTranslation } from '../../i18n/I18nProvider'
import { getBranchDetailLabels } from './inquiryConstants'

const BranchInquiry = (props) => {
  const { translations } = useTranslation()
  const iq = translations?.inquiry || {}
  const detailLabels = getBranchDetailLabels(translations)
  const { data, SendBranchInquirySMS, getBranchListForAdminUpdate, updateAlert } = {
    ...props,
  }
  const { common } = data
  const { loginData, cityList, adminBranchList } = { ...common }
  const [sms, checkSms] = useState(false)
  const [whatsapp, checkWhatsapp] = useState(false)
  const [clearBranch, setClearBranch] = useState(false)
  const [branch, setBranch] = useState({})
  const [city, setCity] = useState({})
  const [branchDetail, setBranchDetail] = useState('')
  const [mobileNumber, setMobileNumber] = useState()
  const [otperror, setOtpError] = useState(false)
  const handleBranchList = (cityId) => {
    const obj = {
      intUserID: 0,
      intCompanyID: loginData?.intCompanyID,
      intCityID: cityId,
      intBookingBranchID: 0,
    }
    getBranchListForAdminUpdate(obj) //api call for get BranchList of dest City
  }
  const handleAlert = (msg = false, nextId = '') => {
    if (typeof msg === 'string' && !isNull(msg)) {
      updateAlert({ show: true, msg, nextId })
    } else {
      updateAlert({ show: false, msg: '', nextId: '' })
      focusElemnt(nextId)
    }
  }
  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0
  }
  const handleGetDetails = () => {
    if (isObjectEmpty(city) || isObjectEmpty(branch)) {
      handleAlert(iq.pleaseSelectCityAndBranch || 'Please Select City & Branch!', `cityName`)
    } else {
      const obj = {
        BranchName: branch.BranchName,
        Address: branch.Address,
        Contact: branch.ContactNo1,
        LocationURL: branch.LocationURL,
      }
      let formattedString = ''
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          formattedString += `${detailLabels[key] || key} - ${obj[key]}\n`
        }
      }
      setBranchDetail(formattedString)
      focusElemnt(`mobileNo`)
    }
  }
  const handleChange = (val) => {
    setOtpError(false)
    setMobileNumber(val)
  }
  const handleSendDetails = () => {
    if (isObjectEmpty(city) || isObjectEmpty(branch)) {
      handleAlert(iq.pleaseSelectCityAndBranch || 'Please Select City & Branch!', `cityName`)
    } else {
      if (mobileNumber?.length < 10 || mobileNumber?.length > 10 || mobileNumber == undefined) {
        setOtpError(true)
      } else {
        if (sms||whatsapp) {
          const obj = {
            CompanyID: branch?.CompanyID,
            BranchID: branch?.BranchID,
            MobileNo: mobileNumber,
            IsSMS: sms?1:0,
            IsWhatsApp: whatsapp?1:0
          }
          SendBranchInquirySMS(obj)
          props.updateModal()
        } else {
          handleAlert(iq.pleaseCheckSmsOrWhatsapp || 'Please Check Either SMS or WhatsApp Checkbox!')
        }
        //to do
        // else {
        //   handleAlert('API Integration Pending for Whatsapp')
        //   props.updateModal()
        // }
      }
    }
  }
  return (
    <>
      <Modal headTxt={iq.sendBranchLocationsDetails || 'Send Branch Locations Details '} width={'55%'} updateModal={props.updateModal}>
        <Stack sx={{ minHeight: 100, minWidth: 650, marginTop: '8px' }} className='sendbranchModal'>
          <Box
            key={`for_otp_lnIp_`}
            className='send-branch-location-detail-container'
            sx={{
              width: '100%',
              display: 'inline-flex',
              paddingLeft: '4px',
              paddingRight: '6px',
            }}
          >
            <Item sx={{ width: '52%' }} className='lr-input-field'>
              <DropDownOA
                label={iq.selectCityName || 'Select City Name'}
                data={cityList || []}
                width="100%"
                searchPlaceholder={iq.selectCity || 'Select City'}
                autoFocus={true}
                isObjArr={true}
                dataKey={`CityName`}
                idKey={`CityID`}
                id={`cityName`}
                tabIndex="4"
                onSelect={(e) => {
                  setCity(e)
                  handleBranchList(e.CityID)
                  setClearBranch(true)
                  setBranch({})
                  setBranchDetail('')
                }}
                nextId={`branchName`}
              />
            </Item>

            <Item sx={{ width: '52%' }} className='lr-input-field'>
              <DropDownOA
                label={iq.selectBranchName || 'Select Branch Name'}
                data={adminBranchList || []}
                width="100%"
                searchPlaceholder={iq.selectBranch || 'Select Branch'}
                isObjArr={true}
                dataKey={`BranchName`}
                idKey={`BranchID`}
                id={`branchName`}
                tabIndex="4"
                resetFlag={clearBranch}
                nextId={`getDetailButton`}
                prevId={`cityName`}
                onSelect={(e) => {
                  setBranch(e)
                  setClearBranch(false)
                }}
              />
            </Item>

            <div className="input--wrapper small_space" style={{ padding: '8px', width: '23%' }}>
              <Button
                id={`getDetailButton`}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem' }}
                onClick={handleGetDetails}
                //  onKeyDown={(e) => navigation2(e, `mobileNo`, `branchName`)}
              >
                {iq.getDetails || 'GET DETAILS'}
              </Button>
            </div>
          </Box>
          <Item sx={{ width: '100%' }} className='branch-inquiry-input-field'>
            <div className={'input--wrapper'} style={{ marginBottom: '0px', paddingLeft: '8px', paddingRight: '8px' }}>
              <Multilineinput
                id={`branchDetail`}
                name="E-Way bill_no"
                label={iq.selectedBranchDetails || 'Selected Branch Details'}
                rows={'4'}
                value={branchDetail}
                disabled
                width="100%"
              />
            </div>
          </Item>
          <Box style={{ display: 'flex', marginBottom: '10px', marginTop: '10px' }} className='lr-input-field'>
            <Item sx={{ width: '55%' }}  >
              <div className={'input--wrapper'} style={{ marginBottom: '0px', paddingLeft: '8px', paddingRight: '8px', display: 'flex' }}>
                <LineInput
                  id={`mobileNo`}
                  type="text"
                  name="Mobile Number"
                  label={iq.mobileNumber || 'Mobile Number'}
                  row="4"
                  value={mobileNumber}
                  onChange={(e) => handleChange(e.target.value)}
                  onKeyDown={(e) => navigation2(e, `smsCheckbox`, `getDetailButton`)}
                />
                <FormControlLabel
                  value="end"
                  control={<Checkbox id={`smsCheckbox`} />}
                  className={`${sms ? 'selcheck' : 'unselcheck'}`}
                  label={iq.sms || 'SMS'}
                  labelPlacement="end"
                  checked={sms}
                  onChange={() => {
                    checkSms(!sms)
                    checkWhatsapp(false)
                    focusElemnt(`whatsappCheckbox`)
                  }}
                  disabled={false}
                  style={{ marginLeft: '10px' }}
                />
                <FormControlLabel
                  value="end"
                  control={<Checkbox id={`whatsappCheckbox`} />}
                  className={`${whatsapp ? 'selcheck' : 'unselcheck'}`}
                  label={iq.whatsapp || 'WhatsApp'}
                  labelPlacement="end"
                  checked={whatsapp}
                  onChange={() => {
                    checkWhatsapp(!whatsapp)
                    checkSms(false)
                    focusElemnt(`sendDetailButton`)
                  }}
                  style={{ marginLeft: '20px' }}
                />
              </div>
            </Item>
            <div className="input--wrapper small_space" style={{ padding: '8px', width: '23%', marginLeft: '10px' }}>
              <Button
                id={`sendDetailButton`}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem' }}
                onClick={handleSendDetails}
                // onKeyDown={(e) => {}}
              >
                {iq.sendDetails || 'SEND DETAILS'}
              </Button>
            </div>
          </Box>
          {otperror ? (
            <Box style={{ marginLeft: '15px', marginTop: '0px', marginBottom: '15px' }}>
              <span style={{ color: 'red', fontSize: '13px' }}>{iq.pleaseEnterValidMobileNumber || 'Please enter valid Mobile Number!'}</span>{' '}
            </Box>
          ) : (
            ''
          )}
        </Stack>
      </Modal>
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { updateModal, updateAlert, SendBranchInquirySMS, getBranchListForAdminUpdate }
export default connect(mapStateToProps, mapDispatchToProps)(BranchInquiry)
